import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container sub_page _activity" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }
const _hoisted_4 = { class: "sub_page_con wrap_1120" }
const _hoisted_5 = { class: "bread_crumbs" }
const _hoisted_6 = { class: "icon_wrap" }
const _hoisted_7 = ["alt"]
const _hoisted_8 = { class: "icon_wrap" }
const _hoisted_9 = ["alt"]
const _hoisted_10 = {
  href: "javascript:void(0)",
  style: {"cursor":"default"}
}
const _hoisted_11 = { class: "sub_page_con_view con_view" }
const _hoisted_12 = { class: "tit_wrap flex_wrap" }
const _hoisted_13 = { class: "con_tit" }
const _hoisted_14 = { class: "con_tit_info" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "writer_info" }
const _hoisted_18 = { class: "con_table_wrap" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  class: "file_list_wrap"
}
const _hoisted_21 = ["src", "onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "btn_wrap _default right_btn" }
const _hoisted_24 = { class: "reply_container wrap_1120" }
const _hoisted_25 = { class: "reply_wrap" }
const _hoisted_26 = { class: "my_reply reply_box" }
const _hoisted_27 = { class: "reply_writer" }
const _hoisted_28 = {
  key: 0,
  class: "replies"
}
const _hoisted_29 = {
  key: 0,
  class: "reply_writer"
}
const _hoisted_30 = {
  key: 1,
  class: "reply_writer"
}
const _hoisted_31 = { class: "reply_date" }
const _hoisted_32 = {
  key: 2,
  class: "reply_btn"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "replay_area_for_mobile" }
const _hoisted_38 = {
  key: 0,
  class: "reply_writer"
}
const _hoisted_39 = {
  key: 1,
  class: "reply_writer"
}
const _hoisted_40 = { class: "reply_area_right" }
const _hoisted_41 = { class: "reply_date" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_47 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"deco_wrap\" data-v-54c7bed2><i class=\"deco_01\" data-v-54c7bed2><img src=\"img/activity_left.png\" data-v-54c7bed2></i><i class=\"deco_02 _small blink4\" data-v-54c7bed2><img src=\"img/b_icon_01.png\" data-v-54c7bed2></i><i class=\"deco_03 _small blink_zoom1\" data-v-54c7bed2><img src=\"img/b_icon_02.png\" data-v-54c7bed2></i><i class=\"deco_04 _xxsmall blink_zoom4\" data-v-54c7bed2><img src=\"img/b_icon_05.png\" data-v-54c7bed2></i><i class=\"deco_05 none_768 spin2 _medium\" data-v-54c7bed2><img src=\"img/b_icon_03.png\" data-v-54c7bed2></i><i class=\"deco_06 none_768 spin_blink3 _small\" data-v-54c7bed2><img src=\"img/b_icon_01.png\" data-v-54c7bed2></i><i class=\"deco_07 none_768 blink_zoom4 _small\" data-v-54c7bed2><img src=\"img/b_icon_02.png\" data-v-54c7bed2></i><i class=\"deco_character\" data-v-54c7bed2><img src=\"img/activity_icon.png\" data-v-54c7bed2></i></div><div class=\"banner_wrap wrap_1120\" data-v-54c7bed2><h2 data-v-54c7bed2>액션 시민 활동</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab(1))),
              class: _normalizeClass([$setup.state.tab === 1 ? 'active' : ''])
            }, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "반성매매 시민활동", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab(2))),
              class: _normalizeClass([$setup.state.tab === 2 ? 'active' : ''])
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "캠페인·이벤트", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab(3))),
              class: _normalizeClass([[$setup.state.tab === 3 ? 'active' : ''], "w_1024_custom_width"])
            }, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "참여하고 싶은 반성매매 활동 제안", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeTab(4))),
              class: _normalizeClass([$setup.state.tab === 4 ? 'active' : ''])
            }, [...(_cache[21] || (_cache[21] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "액션 시민 활동", -1)
            ]))], 2)
          ], 2)
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "icon_wrap"
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createElementVNode("img", {
                src: "img/home_icon.png",
                alt: "홈"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "액션 시민 활동"
            })
          ], -1)),
          _createVNode(_component_router_link, { to: { path: '/board', query: { type: 4 } } }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("액션 시민 활동", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: $setup.state.stateInfo.name
            }, null, 8, _hoisted_7)
          ]),
          _createVNode(_component_router_link, {
            to: { path: '/board', query: { type: 4, idx: $setup.state.stateIdx } },
            style: {"cursor":"default"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.state.stateInfo.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: $setup.state.data.title
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("a", _hoisted_10, _toDisplayString($setup.state.data.title), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString($setup.state.data.title), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.createDate), ".", true)), 1),
              _createElementVNode("span", _hoisted_16, [
                _cache[26] || (_cache[26] = _createElementVNode("span", null, [
                  _createElementVNode("img", {
                    src: "img/view.png",
                    alt: ""
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString($setup.state.data.viewCnt ? $setup.CommonUtils.numberFormat($setup.state.data.viewCnt) : "0"), 1)
              ]),
              _createElementVNode("span", _hoisted_17, [
                _cache[27] || (_cache[27] = _createElementVNode("span", null, "작성자", -1)),
                _createTextVNode(" " + _toDisplayString($setup.state.data.writer), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "content",
              innerHTML: $setup.state.data.content
            }, null, 8, _hoisted_19),
            ($setup.state.data.fileList != null && $setup.state.data.fileList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.fileList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "thum_wrap",
                      key: item.idx
                    }, [
                      _createElementVNode("img", {
                        class: "file_item",
                        src: item.file,
                        alt: "",
                        onClick: ($event: any) => ($setup.showImgModal(item.file))
                      }, null, 8, _hoisted_21),
                      _createElementVNode("button", {
                        class: "common_style",
                        onClick: ($event: any) => ($setup.downloadFile(item.file, item.imgRealName))
                      }, "파일 다운로드", 8, _hoisted_22)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          ($setup.hasAuthForAdmin() || $setup.state.data.meIdx === $setup.user.userInfo.idx)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("button", {
                  class: "common_btn _gray",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
                }, "삭제"),
                _createElementVNode("button", {
                  class: "common_btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.router.push({ name: 'ActionModify', params: { stateIdx: $setup.state.stateIdx, id: $setup.state.idx } })))
                }, " 수정 ")
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "common_btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.router.replace('/board?type=4')))
          }, "목록")
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "tit" }, "댓글 작성", -1)),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[28] || (_cache[28] = _createElementVNode("img", {
                src: "img/my_reply.png",
                alt: ""
              }, null, -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form_state.nickName) = $event)),
                placeholder: "닉네임을 입력해주세요."
              }, null, 512), [
                [_vModelText, $setup.form_state.nickName]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form_state.pw) = $event)),
                placeholder: "비밀번호를 입력해주세요."
              }, null, 512), [
                [_vModelText, $setup.form_state.pw]
              ])
            ]),
            _withDirectives(_createElementVNode("textarea", {
              name: "",
              id: "",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form_state.content) = $event)),
              class: "reply_con custom_scroll"
            }, null, 512), [
              [_vModelText, $setup.form_state.content]
            ]),
            _createElementVNode("button", {
              class: "reply_submit",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.addComment && $setup.addComment(...args))),
              alt: "댓글 등록"
            }, [...(_cache[29] || (_cache[29] = [
              _createElementVNode("img", {
                src: "img/reply_uoload.png",
                alt: ""
              }, null, -1)
            ]))])
          ]),
          ($setup.state.comments.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.comments, (item, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "reply_box",
                    key: idx
                  }, [
                    (!$setup.state.isMobile)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!item.isAdmin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _cache[30] || (_cache[30] = _createElementVNode("img", {
                                  src: "img/reply.png",
                                  alt: ""
                                }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(item.nickname), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[31] || (_cache[31] = [
                                _createElementVNode("img", {
                                  src: "img/symbol.png",
                                  alt: ""
                                }, null, -1),
                                _createTextVNode(" 다시함께상담센터 ", -1)
                              ]))])),
                          _createElementVNode("div", _hoisted_31, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                          ((item.isAdmin && $setup.user.userInfo.isAdmin) || !item.isAdmin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                ($setup.comment_state.idx !== item.idx)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: ($event: any) => ($setup.commentModify(item))
                                      }, "수정", 8, _hoisted_33),
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: ($event: any) => ($setup.confirmCommentRemove(item.idx)),
                                        class: "_gray"
                                      }, "삭제", 8, _hoisted_34)
                                    ], 64))
                                  : ($setup.comment_state.mode === 'modify' && $setup.comment_state.idx === item.idx)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (item.meIdx !== $setup.user.userInfo.idx && !$setup.user.userInfo.isAdmin)
                                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                              key: 0,
                                              type: "password",
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.comment_state.pw) = $event)),
                                              placeholder: "비밀번호를 입력해주세요."
                                            }, null, 512)), [
                                              [_vModelText, $setup.comment_state.pw]
                                            ])
                                          : _createCommentVNode("", true),
                                        _createElementVNode("button", {
                                          type: "button",
                                          onClick: ($event: any) => ($setup.commentSave(item)),
                                          style: {"margin-left":"10px"}
                                        }, "저장", 8, _hoisted_35),
                                        _createElementVNode("button", {
                                          type: "button",
                                          onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.commentCancel())),
                                          class: "_gray"
                                        }, "취소")
                                      ], 64))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.comment_state.idx !== item.idx)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                class: "reply_con",
                                innerHTML: item.content.replaceAll('\n', '<br>')
                              }, null, 8, _hoisted_36))
                            : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                key: 4,
                                class: "reply_con",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.comment_state.content) = $event))
                              }, null, 512)), [
                                [_vModelText, $setup.comment_state.content]
                              ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_37, [
                            (!item.isAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  _cache[32] || (_cache[32] = _createElementVNode("img", {
                                    src: "img/reply.png",
                                    alt: ""
                                  }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.nickname), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_39, [...(_cache[33] || (_cache[33] = [
                                  _createElementVNode("img", {
                                    src: "img/symbol.png",
                                    alt: ""
                                  }, null, -1),
                                  _createTextVNode(" 다시함께상담센터 ", -1)
                                ]))])),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                              ((item.isAdmin && $setup.user.userInfo.isAdmin) || !item.isAdmin)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => ($setup.edit(item)),
                                    style: {"margin-left":"10px"}
                                  }, [...(_cache[34] || (_cache[34] = [
                                    _createElementVNode("img", {
                                      src: "img/kebabIcon.png",
                                      style: {"height":"18px","width":"auto"}
                                    }, null, -1)
                                  ]))], 8, _hoisted_42))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("div", {
                                class: _normalizeClass(["reply_btn", $setup.state.isShowBtn && $setup.comment_state.idx === item.idx ? '_mobile' : ''])
                              }, [
                                ($setup.comment_state.mode !== 'modify' && $setup.comment_state.idx === item.idx)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: ($event: any) => ($setup.commentModify(item))
                                      }, "수정", 8, _hoisted_43),
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: ($event: any) => ($setup.confirmCommentRemove(item.idx)),
                                        class: "_gray"
                                      }, "삭제", 8, _hoisted_44)
                                    ], 64))
                                  : ($setup.comment_state.mode === 'modify' && $setup.comment_state.idx === item.idx)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          onClick: ($event: any) => ($setup.commentSave(item)),
                                          style: {}
                                        }, "저장", 8, _hoisted_45),
                                        _createElementVNode("button", {
                                          type: "button",
                                          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.commentCancel())),
                                          class: "_gray"
                                        }, "취소")
                                      ], 64))
                                    : _createCommentVNode("", true)
                              ], 2), [
                                [_vShow, $setup.state.isShowBtn && $setup.comment_state.idx === item.idx]
                              ])
                            ])
                          ]),
                          ($setup.comment_state.mode === 'modify' && $setup.comment_state.idx === item.idx)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                (item.meIdx !== $setup.user.userInfo.idx)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "password",
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.comment_state.pw) = $event)),
                                      placeholder: "비밀번호를 입력해주세요."
                                    }, null, 512)), [
                                      [_vModelText, $setup.comment_state.pw]
                                    ])
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (($setup.comment_state.mode !== 'modify' && $setup.comment_state.idx === item.idx) || $setup.comment_state.idx !== item.idx)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "reply_con",
                                innerHTML: item.content.replaceAll('\n', '<br>')
                              }, null, 8, _hoisted_47))
                            : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                key: 2,
                                class: "reply_con",
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.comment_state.content) = $event))
                              }, null, 512)), [
                                [_vModelText, $setup.comment_state.content]
                              ])
                        ], 64))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          ($setup.state.comments.length !== 0)
            ? (_openBlock(), _createBlock(_component_PageBtn, {
                key: 1,
                currentPage: $setup.state.page,
                totalLength: $setup.state.totalLength,
                perPage: $setup.state.size,
                onOnPaging: $setup.handlePageChange
              }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal2)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab2,
          title: $setup.state.modalTitle2,
          content: $setup.state.modalContent2,
          onClose: $setup.closeModal2,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}